import Cookies from 'cookies-js';

import { HAS_DOCUMENT } from '@eb/eds-utils';

import { HAS_WINDOW } from '@eb/feature-detection';

import { LOCATION_COOKIE } from '../constants';

// See https://docs.google.com/document/d/1Vg-kyxM34gw71vw_5dLcfzFRhzM3scQ3FKtYUlWXLSA/edit?usp=sharing
export const setLocationData = (locationData) => {
    if (HAS_DOCUMENT) {
        Cookies.set(LOCATION_COOKIE, JSON.stringify(locationData), {
            path: '/',
            secure: true,
        });
    }
};

// See https://docs.google.com/document/d/1Vg-kyxM34gw71vw_5dLcfzFRhzM3scQ3FKtYUlWXLSA/edit?usp=sharing
export const getLocationData = () => {
    if (HAS_DOCUMENT) {
        const locationData = Cookies.get(LOCATION_COOKIE);

        if (locationData) {
            try {
                return JSON.parse(locationData);
            } catch (e) {
                return null;
            }
        }
    }
    return null;
};

export const getBrowserLocationPermission = () => {
    let promise;

    if (HAS_WINDOW && window.navigator && window.navigator.permissions) {
        promise = navigator.permissions.query({ name: 'geolocation' }).then(
            (result) => result.state,
            () => 'Error fetching browser geolocation permissions',
        );
    } else {
        promise = new Promise((_, reject) =>
            reject('No geolocation permissions object'),
        );
    }

    return promise;
};

export const getBrowserLocation = () => {
    let promise;

    if (HAS_WINDOW && window.navigator && window.navigator.geolocation) {
        const locationPromise = new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(resolve, reject);
        });
        const timeOut = new Promise((_, reject) => {
            setTimeout(reject, 6000, 'error');
        });

        promise = Promise.race([locationPromise, timeOut]);
    } else {
        promise = new Promise((_, reject) => reject('No geolocation object'));
    }

    return promise;
};
